import { __decorate } from "tslib";
import Component from "vue-class-component";
import StringUtils from "@/utils/stringUtils";
import ReactiveComponent from "../components/ReactiveComponent";
import Task from "@/services/task";
import { Emit, Prop, PropSync } from "vue-property-decorator";
import ProgressButton from "@/components/ProgressButton.vue";
import Formatter from "../utils/formatter";
let UserForm = class UserForm extends ReactiveComponent {
    constructor() {
        super(...arguments);
        this.emailInvalid = false;
        this.firstnameInvalid = false;
        this.lastnameInvalid = false;
        this.boardsInvalid = false;
        this.allBoards = [];
        this.boardsTask = Task.idle();
    }
    created() {
        this.subscribeQuery({
            tag: "boards",
            options: {
                query: require("@/apollo/queries/allBoards.graphql")
            },
            onTask: task => {
                this.boardsTask = task;
                if (task.isSuccessful) {
                    this.allBoards = task.data.board;
                }
            }
        });
    }
    emitSubmit() { }
    get roleOptions() {
        return [
            { value: "member", text: Formatter.formatUserRole("member") },
            { value: "coach", text: Formatter.formatUserRole("coach") },
            { value: "staff", text: Formatter.formatUserRole("staff") }
        ];
    }
    handleSubmit() {
        if (this.task.isLoading) {
            return;
        }
        this.emailInvalid = !StringUtils.isEmail(this.emailValue);
        this.firstnameInvalid = StringUtils.isBlank(this.firstnameValue);
        this.lastnameInvalid = StringUtils.isBlank(this.lastnameValue);
        this.boardsInvalid = this.boardsValue.length == 0;
        const roleInvalid = StringUtils.isBlank(this.roleValue);
        if (roleInvalid ||
            this.emailInvalid ||
            this.firstnameInvalid ||
            this.lastnameInvalid ||
            this.boardsInvalid) {
            return;
        }
        this.emitSubmit();
    }
    get taskError() {
        return Formatter.formatTaskError(this.task.error);
    }
};
__decorate([
    Prop()
], UserForm.prototype, "task", void 0);
__decorate([
    PropSync("firstname", { type: String, default: "" })
], UserForm.prototype, "firstnameValue", void 0);
__decorate([
    PropSync("lastname", { type: String, default: "" })
], UserForm.prototype, "lastnameValue", void 0);
__decorate([
    PropSync("email", { type: String, default: "" })
], UserForm.prototype, "emailValue", void 0);
__decorate([
    PropSync("role", { type: String, default: "member" })
], UserForm.prototype, "roleValue", void 0);
__decorate([
    PropSync("boards", { type: Array, default: [] })
], UserForm.prototype, "boardsValue", void 0);
__decorate([
    PropSync("optionExtraStrength", { type: Boolean, default: false })
], UserForm.prototype, "optionExtraStrengthValue", void 0);
__decorate([
    PropSync("optionExtraGym", { type: Boolean, default: false })
], UserForm.prototype, "optionExtraGymValue", void 0);
__decorate([
    PropSync("optionExtraAerobic", { type: Boolean, default: false })
], UserForm.prototype, "optionExtraAerobicValue", void 0);
__decorate([
    PropSync("optionExtraDouble", { type: Boolean, default: false })
], UserForm.prototype, "optionExtraDoubleValue", void 0);
__decorate([
    Emit("submit")
], UserForm.prototype, "emitSubmit", null);
UserForm = __decorate([
    Component({
        components: { ProgressButton }
    })
], UserForm);
export default UserForm;
